export default __webpack_public_path__ + "static/media/staff-accounts.e27d5922.png";